module.exports = __webpack_public_path__ + "img/ads.bb3356a7.jpg";